// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3PrWM","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__1dpL-"};